import { LEAD_HASH } from 'Constants/items';

export const getLeadFormName = ({ leadFormActions, form_config, categoryId }) => {
    let leadFormName;

    outer_loop:
    for (let i = 0; i < form_config.length; i++) {
        const actionConfig = form_config[i].action_config;
        const actionNames = form_config[i].actions;

        if (actionNames.includes(leadFormActions[0])) {
            for (let j = 0; j < actionConfig.length; j++) {
                const item = actionConfig[j];
                const conditions = item && item.conditions;

                if (!conditions) {
                    leadFormName = item.form_name;
                    break outer_loop;
                }

                if (conditions.category_ids && conditions.category_ids.includes(categoryId)) {
                    leadFormName = item.form_name;
                    break outer_loop;
                }
            }
        }
    }
    return leadFormName;
};

export const checkIfLoginMandatory = ({ leadFormActions, form_config, categoryId }) => {
    let isLoginMandatory;

    outer_loop:
    for (let i = 0; i < form_config.length; i++) {
        const actionConfig = form_config[i].action_config;
        const actionNames = form_config[i].actions;

        if (actionNames.includes(leadFormActions[0])) {
            for (let j = 0; j < actionConfig.length; j++) {
                const item = actionConfig[j];
                const conditions = item && item.conditions;

                if (!conditions) {
                    isLoginMandatory = item.loginMandatory;
                    break outer_loop;
                }

                if (conditions.category_ids && conditions.category_ids.includes(categoryId)) {
                    isLoginMandatory = item.loginMandatory;
                    break outer_loop;
                }
            }
        }
    }
    return isLoginMandatory;
};

export const mapActiontoHash = action => {
    if (action == 'onNotifyMeTap') {
        return LEAD_HASH.NOTIFYME_HASH;
    }
    return '';
};

export const mapHashToAction = hash => {
    if (hash == LEAD_HASH.NOTIFYME_HASH) {
        return 'onNotifyMeTap';
    }
    return '';
};

export const getSource = selectFrom => {
    if (selectFrom === 'SELL') {
        return 'C2B Landing';
    }
    if (selectFrom === 'BUY') {
        return 'B2C Landing';
    }
    if (selectFrom === 'item_page') {
        return 'ADPV';
    }
    return selectFrom;
};
